import * as actions from './calendar-relocations.actions';
import { CalendarRelocations } from './calendar-relocations.interface';
import { CALENDAR_FLORDERS_INITIAL_STATE } from './calendar-relocations.model';
import * as templateActions from 'app/core/store/template/template.actions';

function calendarRelocationsLoad(state: CalendarRelocations, action: actions.CalendarRelocationsLoadAction): CalendarRelocations {
  return {
    ...state,
    loaded: false,
    loading: false,
    items: [],
    filteredItems: [],
    totalItems: null,
  };
}

function calendarRelocationsLoadSuccess(state: CalendarRelocations, action: actions.CalendarRelocationsLoadSuccessAction): CalendarRelocations {
  return {
    ...state,
    loaded: true,
    loading: false,
    data: {
      legend: [
        {
          id: 'EPS',
          name: '',
          color: '#0067b1', // @accent-blue
          colorType: 'dark',
          amount: 0,
        },
      ],
      dates: action.payload.dates.dates.map(x => {
        return {
          unloadingDate: x.unloadingDate,
          totalNumberOfOrders: x.totalNumberOfOrders,
          florderInfos: [
            ...x.customers.reduce((orders, customer) => {
              return [
                ...orders,
                ...customer.orders.map(order => {
                  return {
                    ...order,
                    customerId: 'EPS',
                  };
                }),
              ];
            }, []),
          ],
        };
      }),
    },
  };
}

function calendarRelocationsLoadFail(state: CalendarRelocations, action: actions.CalendarRelocationsLoadFailAction): CalendarRelocations {
  return {
    ...state,
    loaded: false,
    loading: false,
    items: [],
    filteredItems: [],
    totalItems: null,
  };
}

function calendarRelocationsTemplateSelected(state: CalendarRelocations, action: actions.CalendarRelocationsTemplateSelectedAction): CalendarRelocations {
  return {
    ...state,
    selectedTemplate: state.selectedTemplate == action.payload ? null : action.payload,
    availableDays: state.selectedTemplate == action.payload || !action.payload ? null : state.availableDays,
  };
}

function calendarRelocationsRequestRelocationUnloadingDates(
  state: CalendarRelocations,
  action: actions.CalendarRelocationsRequestRelocationUnloadingDatesAction
): CalendarRelocations {
  return {
    ...state,
    deliveryDaysRequesting: true,
    deliveryDaysRequested: false,
    availableDays: null,
  };
}

function calendarRelocationsRequestRelocationUnloadingDatesSuccess(
  state: CalendarRelocations,
  action: actions.CalendarRelocationsRequestRelocationUnloadingDatesSuccessAction
): CalendarRelocations {
  return {
    ...state,
    deliveryDaysRequesting: false,
    deliveryDaysRequested: true,
    availableDays: {
      full: action.payload.toDates,
      nonFull: action.payload.toDates,
    },
  };
}

function calendarRelocationsRequestRelocationUnloadingDatesFail(
  state: CalendarRelocations,
  action: actions.CalendarRelocationsRequestRelocationUnloadingDatesFailAction
): CalendarRelocations {
  return {
    ...state,
    deliveryDaysRequesting: false,
    deliveryDaysRequested: false,
    availableDays: null,
    selectedTemplate: null,
  };
}

function calendarRelocationsClearState(state: CalendarRelocations, action: actions.CalendarRelocationsClearStateAction): CalendarRelocations {
  return CALENDAR_FLORDERS_INITIAL_STATE;
}

function templateDeleteSuccess(state: CalendarRelocations, action: templateActions.TemplatesDeleteSuccessAction): CalendarRelocations {
  return {
    ...state,
    selectedTemplate: state.selectedTemplate?.id === action.payload.id ? null : state.selectedTemplate,
    availableDays: state.selectedTemplate?.id === action.payload.id ? null : state.availableDays,
  };
}



export function reducer(state = CALENDAR_FLORDERS_INITIAL_STATE, action: actions.Actions | templateActions.Actions): CalendarRelocations {
  let newState: CalendarRelocations = state;

  switch (action.type) {
    case actions.CALENDAR_RELOCATIONS_LOAD:
      newState = calendarRelocationsLoad(state, action);
      break;
    case actions.CALENDAR_RELOCATIONS_LOAD_SUCCESS:
      newState = calendarRelocationsLoadSuccess(state, action);
      break;
    case actions.CALENDAR_RELOCATIONS_LOAD_FAIL:
      newState = calendarRelocationsLoadFail(state, action);
      break;
    case actions.CALENDAR_RELOCATIONS_TEMPLATE_SELECTED:
      newState = calendarRelocationsTemplateSelected(state, action);
      break;
    case actions.CALENDAR_RELOCATIONS_REQUEST_RELOCATION_UNLOADING_DATES:
      newState = calendarRelocationsRequestRelocationUnloadingDates(state, action);
      break;
    case actions.CALENDAR_RELOCATIONS_REQUEST_RELOCATION_UNLOADING_DATES_SUCCESS:
      newState = calendarRelocationsRequestRelocationUnloadingDatesSuccess(state, action);
      break;
    case actions.CALENDAR_RELOCATIONS_REQUEST_RELOCATION_UNLOADING_DATES_FAIL:
      newState = calendarRelocationsRequestRelocationUnloadingDatesFail(state, action);
      break;
    case actions.CALENDAR_RELOCATIONS_CLEAR_STATE:
      newState = calendarRelocationsClearState(state, action);
      break;
    case templateActions.TEMPLATES_DELETE_SUCCESS:
      newState = templateDeleteSuccess(state, action);
      break;
  }

  return newState;
}
